import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDjrTYwexV3RzYbtVEKJeuvLxAe3QNqOHw",
  authDomain: "desibitesweb.firebaseapp.com",
  projectId: "desibitesweb",
  storageBucket: "desibitesweb.firebasestorage.app",
  messagingSenderId: "886525824200",
  appId: "1:886525824200:web:f8c1c018cd87733fe2a9fd",
  measurementId: "G-25DX8YVE4M"
};

const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);

// Offline persistence: reads served from IndexedDB when offline,
// writes queued locally and auto-synced when connection restores.
// Multi-tab manager allows multiple open KDS screens to share the cache.
//
// experimentalForceLongPolling: forces the HTTP long-polling transport instead of the
// streaming WebChannel. WebChannel delivers watch-stream responses in a low-latency,
// interleaved order that — under rapid listen/unlisten churn (React StrictMode double-
// mounting in dev, or many concurrent realtime listeners) — trips an internal Firestore
// assertion in the watch aggregator ("INTERNAL ASSERTION FAILED: Unexpected state ca9 /
// b815", ve:-1), which then corrupts the whole SDK instance. Long-polling batches watch
// responses atomically and avoids that race. No feature/behaviour change; slightly more
// polite to flaky networks (used widely behind proxies) at a negligible cost for our scale.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export const auth = getAuth(app);
